import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { MessageTail } from '@r1-frontend/ui-react/components/svg/chat';
import {
    IndentContainer,
    ListContainer,
    NonStaticContainer,
} from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import * as ST from './styled';

interface IChatMessageProps {
    children: React.ReactNode,
    avatar: React.ReactNode,
    avatarBackground?: COLORS | 'transparent',
    maxWidth?: number,
    type: 'in' | 'out',
}

export const ChatMessage = ({
    avatar,
    avatarBackground,
    children,

    maxWidth = 400,
    type,
}: IChatMessageProps) => {
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);

    const isOutgoing = type === 'out';
    const background = COLORS[isOutgoing ? 'ButtonSecondary' : 'Control'];
    const color = COLORS[isOutgoing ? 'TextSecondary' : 'TextWhite'];
    const tailXCoord = isOutgoing ? '$right' : '$left';

    return (
        <ListContainer
            $mobile={16}
            $desktop={24}
            $wrap={'nowrap'}
            $reverse={isOutgoing}
        >
            <ST.Avatar
                data-test={'chat-message-avatar'}
                $background={avatarBackground || background}
            >
                {avatar}
            </ST.Avatar>
            <NonStaticContainer
                $united={{
                    $position: 'relative',
                }}
            >
                <ST.MessageBody
                    data-test={'chat-message-body'}
                    $desktop={32}
                    $mobile={16}
                    $background={background}
                    $maxWidth={maxWidth}
                    $color={color}
                >
                    <IndentContainer $mobile={[16]} $desktop={[24, 32]}>
                        {children}
                    </IndentContainer>
                    <ST.MessageTailContainer
                        data-test={'chat-message-tail-container'}
                        $rotate={isOutgoing ? 0 : 180}
                        $mobile={{
                            $bottom: 0,
                            [tailXCoord]: -8,
                        }}
                        $desktop={{
                            $bottom: 0,
                            [tailXCoord]: -13,
                        }}
                    >
                        <MessageTail
                            color={background}
                            width={isMobile ? 19 : 42}
                            height={isMobile ? 29 : 63}
                        />
                    </ST.MessageTailContainer>
                </ST.MessageBody>
            </NonStaticContainer>
        </ListContainer>
    );
};
